<template>
  <div class="counter">
    <div class="counter__details">
      <span class="counter__details--number">{{ number }}</span>
      <span class="counter__details--title">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    number: { required: true, type: [Number] },
    title: { required: true, type: [String] },
  },
}
</script>

<style lang="scss" scoped>
.counter {
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 3px;
}
.counter__details {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0;
}
.counter__details--number {
  font-size: 36px;
  line-height: 36px;
  font-weight: 400;
}
.counter__details--title {
  font-size: 12px;
  text-align: center;
}
</style>
